import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText,
  Collapse
} from 'reactstrap';
import { connect } from 'react-redux';
import { IBienPrix, IAuthReduxProps, ITarget, IVente } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { editBienPrice } from '../../flux/actions/venteActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faCheckCircle, faLock, faLockOpen, faCheckSquare, faSquare, faAngleDown, faFilePdf, faFileImage, faTimes, faHandRock } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import { getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
import { instantUploadToFTP } from '../pdf/PDFLink';
import { constants } from '../../types/constants';
import NumberFormat from 'react-number-format';
import { useDropzone } from 'react-dropzone';
import { PRIVILEGE } from '../../types/privileges';

const BienPrix = ({
  modal,
  setModal,
  modalData,
  editBienPrice,
  editCallback,
  auth
 }: IBienPrix) => {
  const [idValue, setIdValue] = useState<number | undefined>(undefined);
  const [venteIdValue, setVenteIdValue] = useState<number | undefined>(undefined);
  const [designationValue, setDesignationValue] = useState('');

  const [ignoreMin, setIgnoreMin] = useState(false);
  const [noRemise, setNoRemise] = useState(false);
  const [remiseValue, setRemiseValue] = useState(0);
  const [remiseTotalValue, setRemiseTotalValue] = useState(true);
  const [prixMinValue, setPrixMinValue] = useState(0);
  const [prixMinTotalValue, setPrixMinTotalValue] = useState(false);
  const [prixBienValue, setPrixBienValue] = useState(0);
  const [prixBienTotalValue, setPrixBienTotalValue] = useState(false);
  const [remiseMaxValue, setRemiseMaxValue] = useState(0);
  const [remiseMaxTotalValue, setRemiseMaxTotalValue] = useState(false);
  const [prixValue, setPrixValue] = useState(0);
  const [prixTotalValue, setPrixTotalValue] = useState(false);
  const [netValue, setNetValue] = useState(0);
  const [netTotalValue, setNetTotalValue] = useState(false);
  const [showRemiseM, setShowRemiseM] = useState(true);
  const [showPrixM, setShowPrixM] = useState(true);
  const [remiseLimitFlag, setRemiseLimitFlag] = useState(false);
  const [prixLimitFlag, setPrixLimitFlag] = useState(false);
  const [prixBienLimitFlag, setPrixBienLimitFlag] = useState(false);
  const [prixMinLimitFlag, setPrixMinLimitFlag] = useState(false);
  const [prixMinOpen, setPrixMinOpen] = useState(!modalData?.contrat);
  const remiseRef = useRef<HTMLInputElement>(document.createElement("input"));
  const prixRef = useRef<HTMLInputElement>(document.createElement("input"));
  const prixBienRef = useRef<HTMLInputElement>(document.createElement("input"));
  const prixMinRef = useRef<HTMLInputElement>(document.createElement("input"));

  const [superficie, setSuperficie] = useState(1);
  const [commentValue, setCommentValue] = useState('');
  const [changeBienValue, setChangeBienValue] = useState(false);

  const totalM = Number((prixTotalValue ? prixValue / superficie : prixValue) - (remiseTotalValue ? remiseValue / superficie : remiseValue))
  const total = Number((prixTotalValue ? prixValue : prixValue * superficie) - (remiseTotalValue ? remiseValue : remiseValue * superficie))
  const totalLimitFlag = total >= (prixMinTotalValue ? prixMinValue : prixMinValue * superficie)
  
  const [noDoc, setNoDoc] = useState(false);
  const [joinDocuments, setJoinDocuments] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ['application/pdf', 'image/*'],
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setJoinDocuments(acceptedFiles);
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type PDF ou Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();
  
  const handleToggle = () => setModal(!modal);

  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value)
  const changeChangeBienHandle = (e) => {
    setChangeBienValue(e.target.checked);
  }
  
  const noDocChangeHandle = e => setNoDoc(e.target.checked)

  useEffect(() => {
    setSuperficie((modalData?.contrat ? modalData.contrat.SUPERFICIE : modalData?.SUPERFICIE) ? Number(modalData?.contrat ? modalData.contrat.SUPERFICIE : modalData?.SUPERFICIE) : 1)
  }, [modalData])

  const prixMinTotalChangeHandle = e => {
    if(!modalData)
      return
    if(e){
      if(!prixMinTotalValue){
        setPrixMinTotalValue(true);
        setPrixMinValue(Number(prixMinValue) * superficie)
      }
    }
    else{
      if(prixMinTotalValue){
        setPrixMinTotalValue(false);
        setPrixMinValue(Number(prixMinValue) / superficie)
      }
    }
  }

  const prixTotalChangeHandle = e => {
    if(!modalData)
      return
    if(e){
      if(!prixTotalValue){
        setPrixTotalValue(true);
        setPrixValue(Number(prixValue) * superficie)
      }
    }
    else{
      if(prixTotalValue){
        setPrixTotalValue(false);
        setPrixValue(Number(prixValue) / superficie)
      }
    }
  }

  const netTotalChangeHandle = e => {
    if(!modalData)
      return
    if(e){
      if(!netTotalValue){
        setNetTotalValue(true);
        setNetValue(Number(netValue) * superficie)
      }
    }
    else{
      if(netTotalValue){
        setNetTotalValue(false);
        setNetValue(Number(netValue) / superficie)
      }
    }
  }

  const prixBienTotalChangeHandle = e => {
    if(!modalData)
      return
    if(e){
      if(!prixBienTotalValue){
        setPrixBienTotalValue(true);
        setPrixBienValue(Number(prixBienValue) * superficie)
      }
    }
    else{
      if(prixBienTotalValue){
        setPrixBienTotalValue(false);
        setPrixBienValue(Number(prixBienValue) / superficie)
      }
    }
  }

  const remiseMaxTotalChangeHandle = e => {
    if(!modalData)
      return
    setRemiseMaxTotalValue(!!e)
    return
    if(e){
      if(!remiseMaxTotalValue){
        setRemiseMaxTotalValue(true);
      }
    }
    else{
      if(remiseMaxTotalValue){
        setRemiseMaxTotalValue(false);
      }
    }
  }

  // const remiseTotalChangeHandle = e => {
  //   if(!modalData)
  //     return
  //   setRemiseTotalValue(!!e)
  //   return
  //   if(e){
  //     if(!remiseMaxTotalValue){
  //       setRemiseMaxTotalValue(true);
  //     }
  //   }
  //   else{
  //     if(remiseMaxTotalValue){
  //       setRemiseMaxTotalValue(false);
  //     }
  //   }
  // }
  
  useEffect(() => {
    const total = (prixBienTotalValue ? Number(prixBienValue || 0) : (Number(prixBienValue || 0) * superficie)) - (prixMinTotalValue ? Number(prixMinValue || 0) : (Number(prixMinValue || 0) * superficie))
    setRemiseMaxValue(remiseMaxTotalValue ? total : total / superficie)
  }, [remiseMaxTotalValue, prixBienValue, prixMinValue, superficie])
  
  useEffect(() => {
    if(noRemise)
      setRemiseValue(0)
    else{
      const total = (prixTotalValue ? Number(prixValue || 0) : (Number(prixValue || 0) * superficie)) - (netTotalValue ? Number(netValue || 0) : (Number(netValue || 0) * superficie))
      setRemiseValue(remiseTotalValue ? total : total / superficie)
    }
  }, [remiseTotalValue, prixValue, netValue, superficie, noRemise])

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  useEffect(() => {
    let invalid = true;
    if(modalData)
      if((prixTotalValue && prixValue >= Number(modalData.PRIX_VENTE || 0) / 10 && prixValue < modalData.PRIX_VENTE * 10)
      || (!prixTotalValue && (!modalData.PRIX_M || (prixValue >= Number(modalData.PRIX_M || 0) / 10 && prixValue < modalData.PRIX_M * 10))))
        invalid = false;
    setPrixLimitFlag(invalid)
  }, [modalData, prixValue, prixTotalValue])

  useEffect(() => {
    let invalid = true;
    if(modalData)
      if((prixBienTotalValue && prixBienValue >= Number(modalData.PRIX_VENTE || 0) / 10 && prixBienValue < modalData.PRIX_VENTE * 10)
      || (!prixBienTotalValue && (!modalData.PRIX_M || (prixBienValue >= Number(modalData.PRIX_M || 0) / 10 && prixBienValue < modalData.PRIX_M * 10))))
        invalid = false;
    setPrixBienLimitFlag(invalid)
  }, [modalData, prixBienValue, prixBienTotalValue])

  useEffect(() => {
    let invalid = true;
    if(modalData)
      if((prixMinTotalValue && prixMinValue >= Number(modalData.PRIX_VENTE_MIN || 0) / 10 && prixMinValue < modalData.PRIX_VENTE_MIN * 10)
      || (!prixMinTotalValue && (!modalData.PRIX_M_MIN || (prixMinValue >= Number(modalData.PRIX_M_MIN || 0) / 10 && prixMinValue < modalData.PRIX_M_MIN * 10))))
        invalid = false;
    setPrixMinLimitFlag(invalid)
  }, [modalData, prixMinValue, prixMinTotalValue])

  useEffect(() => {
    let invalid = true;
    if(modalData)
      if((remiseTotalValue && remiseValue < modalData.PRIX_VENTE)
      || (!remiseTotalValue && (!modalData.PRIX_M || (remiseValue < modalData.PRIX_M))))
        invalid = false;
    setRemiseLimitFlag(invalid)
  }, [modalData, remiseValue, remiseTotalValue])

  const modalOpenedHandle = () => {
    if(modalData && modalData !== ''){
      setIdValue(modalData["id"]);
      setVenteIdValue(modalData?.contrat?.id);
      setDesignationValue(modalData["DESIGNATION"]);
      const remise = Number(modalData.contrat ? ((modalData.contrat.REMISE_VALIDEE === 0 || modalData.contrat.REMISE_VALIDEE === -1) ? 0 : (modalData.contrat.REMISE || 0)) : 0)
      const net = Number(modalData.contrat ? (modalData.contrat.PRIX_NET || 0) : 0)
      const prix = net + remise
      // const prix = Number(modalData.contrat ? (Number(modalData.contrat.PRIX_NET || 0) + remise) : (modalData.PRIX_VENTE || 0))
      const prixMin = Number(modalData.PRIX_VENTE_MIN || 0)
      const prixBien = Number(modalData.PRIX_VENTE || 0)
      // const prixMinTInit = Number(modalData.PRIX_VENTE_MIN_INIT || 0)
      // const prixMinMInit = Number(modalData.PRIX_M_MIN_INIT || 0)
      if(modalData["TYPE_2"] && modalData["TYPE_2"].toUpperCase() === constants.APPARTEMENT){
        setShowRemiseM(false);
        setShowPrixM(false);
        setPrixTotalValue(true);
        setNetTotalValue(true);
        setPrixBienTotalValue(true);
        setPrixMinTotalValue(true);
        setRemiseMaxTotalValue(true);
        setPrixValue(prix);
        setNetValue(net);
        setPrixBienValue(prixBien);
        setPrixMinValue(prixMin);
      }
      else{
        setShowRemiseM(true);
        setShowPrixM(true);
        setPrixTotalValue(false);
        setNetTotalValue(false);
        setPrixBienTotalValue(false);
        setPrixMinTotalValue(false);
        setRemiseMaxTotalValue(false);
        setPrixValue(prix / superficie)
        setNetValue(net / superficie);
        setPrixBienValue(prixBien / superficie);
        setPrixMinValue(prixMin / superficie);
      }
      setRemiseTotalValue(true);
      setRemiseValue(remise)
      // setPrixMinTInitValue(prixMinTInit);
      // setPrixMinMInitValue(prixMinMInit);
      // setCommentValue(modalData?.contrat?.priceChangedComment || modalData?.priceChangedComment || '')
    }
  };

  const modalClosedHandle = () => {
    setIdValue(undefined);
    setVenteIdValue(undefined);
    setDesignationValue('');
    setShowRemiseM(true);
    setShowPrixM(true);
    setRemiseTotalValue(true);
    setPrixBienTotalValue(false);
    setPrixMinTotalValue(false);
    setRemiseMaxTotalValue(false);
    setPrixTotalValue(false);
    setNetTotalValue(false);
    setPrixMinValue(0)
    // setPrixMinTInitValue(0)
    // setPrixMinMInitValue(0)
    setPrixBienValue(0)
    setPrixValue(0)
    setNetValue(0)
    setRemiseValue(0)
    setCommentValue('')
    setChangeBienValue(false)
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModal(false);
      alert.success(`Prix changé avec succès`);
      if(editCallback)
        editCallback()
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!idValue)
      return
    if(venteIdValue && !ignoreMin && total < (prixMinTotalValue ? prixMinValue : prixMinValue * superficie)){
      alert.error("Le prix de vente NET est très bas");
      return
    }
    if(!noDoc && !joinDocuments?.length){
      alert.error("Veuillez sélectionner un document");
      return
    }
    // if(noDoc && !joinDocuments?.length && !commentValue){
    //   alert.error("Veuillez soit sélectionner un document soit saisir un commentaire");
    //   return
    // }
    const remise = noRemise ? 0 : remiseTotalValue ? remiseValue : remiseValue * superficie
    const prixBien = prixBienTotalValue ? prixBienValue : prixBienValue * superficie
    const prixBienM = prixBienTotalValue ? prixBienValue / superficie : prixBienValue
    const prix = (netTotalValue ? netValue : netValue * superficie)
    const prixM = (netTotalValue ? netValue / superficie : netValue)
    // const prix = (prixTotalValue ? prixValue : prixValue * superficie) - remise
    // const prixM = (prixTotalValue ? prixValue / superficie : prixValue) - remise / superficie
    const prixMin = prixMinTotalValue ? prixMinValue : prixMinValue * superficie
    const prixMinM = prixMinTotalValue ? prixMinValue / superficie : prixMinValue
    setDisableSubmit(true);

    const uploadCallback = (upload: any = undefined) => {
      editBienPrice(idValue, venteIdValue, !!modalData?.contrat ? 1 : 0, !!modalData?.contrat && !changeBienValue ? 0 : 1, prix, prixM, prixBien, prixBienM, remise, prixMin, prixMinM, commentValue, auth?.user?.id, upload, callback)
    }

    if(joinDocuments?.length){
      var reader = new FileReader();
      reader.onload = function() {
        var arrayBuffer = this.result,
          codedBuffer: string = "";
        (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
            codedBuffer += String.fromCharCode(byte);
        });
        uploadCallback({codedBuffer, isPdf: joinDocuments[0].type === "application/pdf" ? 1 : 0});
      }
      reader.readAsArrayBuffer(joinDocuments[0]);
    }
    else
      uploadCallback()
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-large">
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Changement de prix{designationValue ? ` - ${designationValue}` : ""}{(modalData?.contrat ? modalData.contrat.SUPERFICIE : modalData?.SUPERFICIE) ? ` (${Number(modalData?.contrat ? modalData.contrat.SUPERFICIE : modalData?.SUPERFICIE)}m²)` : ""}</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              {false && !!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_PRIX_MIN) && <Row>
                <Container className="CardInfo" style={{border: "2px darkred dashed"}}>
                  <div className="formulaCollapseOpener" onClick={() => setPrixMinOpen(e => !e)}>
                    <div style={{fontFamily: "'Ultra', sans-serif", fontStyle: "italic", letterSpacing: "2px"}}><FontAwesomeIcon icon={faPen} />&nbsp;Prix Minimum du Bien</div>
                    <FontAwesomeIcon icon={faAngleDown} className={`flipIcon${prixMinOpen ? " flipped" : ""}`} />
                  </div>
                  <Collapse className="mt-2" isOpen={prixMinOpen}>
                    <Row>
                      <Col xs="12" style={{border: "none"}}>
                        <span>Prix (MIN) initial:&nbsp;</span>{Number(modalData.PRIX_M_MIN_INIT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH/M² ({Number(modalData.PRIX_VENTE_MIN_INIT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH le total)
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" style={{border: "none"}}>
                        <FormGroup>
                          <Label for="prixMin">Prix (MIN) actuel</Label>
                          <span style={{display: "block", whiteSpace: "nowrap"}}>
                            {showPrixM && <span className={`bienCardRadio${!prixMinTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixMinTotalChangeHandle(false)}><FontAwesomeIcon icon={!prixMinTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                            <span className={`bienCardRadio${prixMinTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixMinTotalChangeHandle(true)}><FontAwesomeIcon icon={prixMinTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                          </span>
                          <InputGroup className="quantityInputGroup">
                            <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="prixMin" pattern="[0-9]*" invalid={prixMinLimitFlag} innerRef={prixMinRef} value={prixMinValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setPrixMinValue(e.value ? +e.value : 0)}/* onChange={prixChangeHandler}*/ className="form-control" />
                            <InputGroupAddon addonType="append">
                              <InputGroupText>DH</InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Collapse>
                </Container>
              </Row>}
              {!!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER) && <Row>
                <Col xs="12" sm="6" className="fullFlexCenter">
                  <CustomInput type="switch" id="ignoreMin" name="ignoreMinSwitch" label="Ignorer le prix min" checked={ignoreMin} onChange={e => setIgnoreMin(e.target.checked)} />
                </Col>
                <Col xs="12" sm="6" className="fullFlexCenter">
                  <CustomInput type="switch" id="noRemise" name="noRemiseSwitch" label="Ajustement de prix" checked={noRemise} onChange={e => setNoRemise(e.target.checked)} />
                </Col>
              </Row>}
              <Row>
                <Col xs="12" sm="4" style={{border: "none"}}>
                  <FormGroup>
                    <Label for="prixMin" className="mb-0">Prix (MIN)</Label>
                    <span style={{display: "block", whiteSpace: "nowrap"}}>
                      {showPrixM && <span className={`bienCardRadio${!prixMinTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixMinTotalChangeHandle(false)}><FontAwesomeIcon icon={!prixMinTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                      <span className={`bienCardRadio${prixMinTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixMinTotalChangeHandle(true)}><FontAwesomeIcon icon={prixMinTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="prixMin" pattern="[0-9]*" disabled={!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_PRIX_MIN)} invalid={prixMinLimitFlag} innerRef={prixMinRef} value={prixMinValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setPrixMinValue(e.value ? +e.value : 0)}/* onChange={prixChangeHandler}*/ className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col xs="12" sm="4">
                  <FormGroup>
                    <Label for="prixBien" className="mb-0">Prix Catalogue (MAX)</Label>
                    <span style={{display: "block", whiteSpace: "nowrap"}}>
                      {showPrixM && <span className={`bienCardRadio${!prixBienTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixBienTotalChangeHandle(false)}><FontAwesomeIcon icon={!prixBienTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                      <span className={`bienCardRadio${prixBienTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixBienTotalChangeHandle(true)}><FontAwesomeIcon icon={prixBienTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="prixBien" pattern="[0-9]*" disabled={!!modalData?.contrat} invalid={prixBienLimitFlag} innerRef={prixBienRef} value={prixBienValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setPrixBienValue(e.value ? +e.value : 0)}/* onChange={prixChangeHandler}*/ className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col xs="12" sm="4">
                  <FormGroup>
                    <Label className="mb-0">Remise maximale</Label>
                    <span style={{display: "block", whiteSpace: "nowrap"}}>
                      {showPrixM && <span className={`bienCardRadio${!remiseMaxTotalValue ? " selectedBCRadio" : ""}`} onClick={() => setRemiseMaxTotalValue(false)}><FontAwesomeIcon icon={!remiseMaxTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                      <span className={`bienCardRadio${remiseMaxTotalValue ? " selectedBCRadio" : ""}`} onClick={() => setRemiseMaxTotalValue(true)}><FontAwesomeIcon icon={remiseMaxTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} pattern="[0-9]*" disabled value={remiseMaxValue} defaultValue={0} decimalScale={2} className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              {!!modalData?.contrat && <Row>
                <Col xs="12" sm="4">
                  <FormGroup>
                    <Label for="prix" className="mb-0">Prix de vente <span style={{color: "darkred"}}>(sans remise)</span></Label>
                    <span style={{display: "block", whiteSpace: "nowrap"}}>
                      {showPrixM && <span className={`bienCardRadio${!prixTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixTotalChangeHandle(false)}><FontAwesomeIcon icon={!prixTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                      <span className={`bienCardRadio${prixTotalValue ? " selectedBCRadio" : ""}`} onClick={() => prixTotalChangeHandle(true)}><FontAwesomeIcon icon={prixTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="prix" pattern="[0-9]*" invalid={prixLimitFlag} placeholder="Prix de vente..." innerRef={prixRef} value={prixValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setPrixValue(e.value ? +e.value : 0)}/* onChange={prixChangeHandler}*/ className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col xs="12" sm="4">
                  <FormGroup>
                    <Label for="demanderemise" className="mb-0"><strong>Remise</strong></Label>
                    <span style={{display: "block", whiteSpace: "nowrap"}}>
                      {showRemiseM && <span className={`bienCardRadio${!remiseTotalValue ? " selectedBCRadio" : ""}`} onClick={() => setRemiseTotalValue(false)}><FontAwesomeIcon icon={!remiseTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                      <span className={`bienCardRadio${remiseTotalValue ? " selectedBCRadio" : ""}`} onClick={() => setRemiseTotalValue(true)}><FontAwesomeIcon icon={remiseTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={true} id="demanderemise" pattern="[0-9]*" disabled invalid={remiseLimitFlag} placeholder="Remise..." innerRef={remiseRef} value={remiseValue} defaultValue={0} decimalScale={2} /*onFocus={focusHandler} onValueChange={e => setRemiseValue(e.value ? +e.value : 0)}/* onChange={remiseChangeHandler}*/ className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col xs="12" sm="4">
                  <FormGroup>
                    <Label for="net" className="mb-0">Prix Net <span style={{color: "darkgreen"}}>(avec remise)</span></Label>
                    <span style={{display: "block", whiteSpace: "nowrap"}}>
                      {showPrixM && <span className={`bienCardRadio${!netTotalValue ? " selectedBCRadio" : ""}`} onClick={() => netTotalChangeHandle(false)}><FontAwesomeIcon icon={!netTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>}
                      <span className={`bienCardRadio${netTotalValue ? " selectedBCRadio" : ""}`} onClick={() => netTotalChangeHandle(true)}><FontAwesomeIcon icon={netTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                    </span>
                    <InputGroup className="quantityInputGroup">
                      <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="net" pattern="[0-9]*"/* invalid={prixLimitFlag}*/ style={{backgroundColor: "white", ...(!ignoreMin && ((netTotalValue ? netValue : netValue * superficie) < (prixMinTotalValue ? prixMinValue : prixMinValue * superficie)) ? {color: "darkred"} : {})}} value={netValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setNetValue(e.floatValue || 0)} /* onChange={prixChangeHandler}*/ className="form-control" />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>DH</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>}
              {/* {!!modalData?.contrat && <Row>
                <Col xs="12" style={{fontSize: "large", ...(!totalLimitFlag ? {color: "red"} : {})}}>
                  <strong>Prix avec remise:&nbsp;</strong>{totalM.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH/M² ({total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH le total)
                </Col>
              </Row>} */}
              <Row className="mt-3">
                <Col xs="12">
                  <FormGroup>
                    <Label for="comment" className="mb-0">Commentaire</Label>
                    <Input id="comment" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              {/* {!!modalData?.contrat && <Row>
                <Col xs="12">
                  <FormGroup className="formCustomSwitch">
                    <Label for="changeBien">Changer le prix catalogue également</Label>
                    <CustomInput type="switch" id="changeBien" name="changeBienSwitch" checked={changeBienValue} onChange={changeChangeBienHandle} />
                  </FormGroup>
                </Col>
              </Row>} */}
              <Row>
                <Col xs="12">
                  <div style={{position: "relative"}}>
                    <section>
                      <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                        <input {...getInputProps()} />
                        {joinDocuments?.length ? <aside className="thumbContainer">
                          <div className="thumbDelete" onClick={e => (e.stopPropagation(), setJoinDocuments([]))} title="Supprimer le document"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                          <div className="thumb" style={{height: "auto"}} key={joinDocuments[0].name}>
                            <div className="thumbInner">
                              <span className="thumbFileName"><FontAwesomeIcon icon={faFilePdf} />&nbsp;{joinDocuments[0].name}</span>
                            </div>
                          </div>
                        </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> <FontAwesomeIcon icon={faFilePdf} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le <span style={{fontWeight: 600}}>{"document"}</span> ici</span>}
                      </div>
                    </section>
                    <div style={{display: "flex", justifyContent: "space-between", fontStyle: "italic", fontSize: "x-small", margin: "2px 0"}}>
                      {!joinDocuments?.length ? <div style={{display: "flex"}}>
                        <input type="checkbox" id="noDoc" checked={noDoc} onChange={noDocChangeHandle} style={{marginRight: "3px"}} />
                        <Label for="noDoc" check>Je ne dispose pas de document</Label>
                      </div> : <div></div>}
                      <a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a>
                    </div>
                    {/* <div className="bottomFloatingInputText text-right"><a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a></div> */}
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className={`btn btn-success linesConfirmationBtn linesDeleteBtn`}
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faPen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { editBienPrice })(BienPrix);
